/**
 * Ask for an exception (workbench D379): AIOE's own half beside the mirrored contract (policyExceptions.ts), for the
 * console, the phone and the Inbox record's actions. The workbench never reads these.
 *
 *   GET  /admin/v1/exception-requests[?state=&projectId=]  → { requests: ExceptionRequestAdminView[] }: pending first
 *                                                            (oldest first), then the answered ones, newest first
 *   POST /admin/v1/exception-requests/:id/approve { hours, note? } → { request }: hours at most what was asked
 *   POST /admin/v1/exception-requests/:id/decline { reason }       → { request }
 *   POST /admin/v1/exception-requests/:id/revoke  { reason? }      → { request }: an approved one, before its end
 *
 * The Inbox record filed for the administrators carries `POLICY_EXCEPTION_DECIDE_RPC` with
 * `{ requestId, decision: "approve", hours }` and `{ requestId, decision: "decline" }`; acting on Decline takes
 * `{ reason }` in the body.
 */
import { z } from "zod";
import { MAX_EXCEPTION_HOURS } from "./policyExceptions.js";
/** The Inbox record's Approve and Decline, as the contract names it. */
export const POLICY_EXCEPTION_DECIDE_RPC = "aioe.policy.exception.decide";
export const exceptionApproveSchema = z.object({
    /** For how long, in hours: at most what was asked. */
    hours: z.number().int().min(1).max(MAX_EXCEPTION_HOURS),
    note: z.string().trim().max(2000).optional(),
});
export const exceptionDeclineSchema = z.object({ reason: z.string().trim().min(1, "say why it is declined").max(2000) });
export const exceptionRevokeSchema = z.object({ reason: z.string().trim().max(2000).optional() });
/** "Choose how long" for an approval: the person's own lengths, never longer than they asked. */
export function approvalLengths(asked) {
    const lengths = [8, 24, 7 * 24, 30 * 24, 90 * 24].filter((h) => h < asked).map((hours) => ({ hours, words: hoursWords(hours) }));
    return [...lengths, { hours: asked, words: `${hoursWords(asked)}, as asked` }];
}
/** "8 hours", "a day", "a week", "30 days". */
export function hoursWords(hours) {
    if (hours === 24)
        return "a day";
    if (hours === 7 * 24)
        return "a week";
    if (hours % 24 === 0)
        return `${hours / 24} days`;
    return hours === 1 ? "an hour" : `${hours} hours`;
}
//# sourceMappingURL=policyExceptionsAdmin.js.map